var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVentilationRate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 375 302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;fill:#C3E3F1;enable-background:new;}\n\t.st1{fill:#87C8E4;}\n\t.st2{fill:none;stroke:#87C8E4;stroke-width:2.5988;stroke-miterlimit:10;}\n\t.st3{fill:#C3E3F1;}\n\t.st4{fill:#212056;}\n\t.st5{fill:#468EAD;stroke:#42515A;stroke-width:1.2561;stroke-miterlimit:10;}\n\t.st6{fill:#468EAD;}\n\t.st7{fill:#FFFFFF;stroke:#43525A;stroke-width:1.2994;stroke-miterlimit:10;}\n\t.st8{fill:#468EAD;stroke:#42515A;stroke-width:1.3254;stroke-miterlimit:10;}\n\t.st9{fill:#3E6D85;}\n\t.st10{fill:#42515A;}\n\t.st11{fill:#FEC010;}\n\t.st12{fill:#FFFFFF;}\n\t.st13{fill:#87C8E4;stroke:#43525A;stroke-width:1.2474;stroke-miterlimit:10;}\n\t.st14{fill:#49ABD7;stroke:#49ABD7;stroke-width:0.4678;stroke-miterlimit:10;}\n\t.st15{fill:#49ABD7;stroke:#43525A;stroke-width:0.8663;stroke-miterlimit:10;}\n\t.st16{fill:#3E6D85;stroke:#43525A;stroke-width:0.8663;stroke-miterlimit:10;}\n\t.st17{fill:#C3E3F1;stroke:#43525A;stroke-width:0.8663;stroke-miterlimit:10;}\n\t.st18{fill:none;stroke:#FEC010;stroke-width:2.5988;stroke-miterlimit:22.93;}\n\t.st19{fill:none;stroke:#FEC010;stroke-width:2.5988;stroke-linecap:round;stroke-linejoin:round;}\n\t.st20{fill:none;stroke:#FEC010;stroke-width:2.7634;stroke-miterlimit:22.93;}\n\t.st21{fill:none;stroke:#FEC010;stroke-width:2.7634;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    className: "st0",
    width: 375,
    height: 302
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 260.2,
    className: "st1",
    width: 375,
    height: 41.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 255.9,
    x2: 375,
    y2: 255.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M161.5,199c-8.3-0.3-13.4,0.7-16.9,10.8c-2.7,7.7-4,0.3-10.5,6.8c-4,4.1-6.2,8-15.9,0.6 c-9.8-7.4-16.3-2.7-16.3-2.7c3.7,1.1,7.3,2.8,10.5,4.9c11,7.6,20.7,15.7,21.7,12c1-3.6,12.3,5.8,17.1,3.5c4.8-2.3,5.8-7.8,3.6-12.9 c-2.2-5.1,6.1-4.6,10.3-8.4S172,199.2,161.5,199z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M177.2,208.3c-2.4,8.7-6.2,7.8-12.6,11.2s5.8,8.9,13.5,1.5C188.8,210.8,179.2,201.6,177.2,208.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.7,239.4c22.1,7.1,25-4.7,16.5-13.6c5.3,7.9,4.2,19.2-16.7,11.9l-0.5-0.2c-0.2,0.3-1,1.6-3.7,2.9 c-8.2,4.2-19.6-15.1-29.4-19C119.4,227.7,134.5,255.6,141.7,239.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M264,147.5h67.4c2.8,0,5-2.2,5-5H259C259,145.3,261.3,147.5,264,147.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.4,
    y: 35.1,
    className: "st5",
    width: 82.5,
    height: 105.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 37.6,
    className: "st6",
    width: 77.2,
    height: 101
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.7,
    y: 40.8,
    className: "st7",
    width: 71.1,
    height: 97.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M332,41.6v97h-8.3c1.1-28,1.8-63.9-5.6-77.6c-7.4-13.7-34.2-17.8-51.9-19.4H332z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.9,
    y: 66.3,
    className: "st6",
    width: 74.8,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.3,
    y: 39.9,
    className: "st6",
    width: 3.6,
    height: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M341.5,143.3H254c-1.5,0-2.7-1.2-2.7-2.7v-2.2c0-1.5,1.2-2.7,2.7-2.7h87.5c1.5,0,2.7,1.2,2.7,2.7v2.2 C344.2,142.1,343,143.3,341.5,143.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M254.4,136.1H341c1.4,0,2.5,1.2,2.5,2.6v1.6c0,0.2,0,0.4-0.1,0.6c-0.3-1.1-1.3-1.9-2.4-2h-86.5 c-1.2,0-2.2,0.8-2.4,2c-0.1-0.2-0.1-0.4-0.1-0.6v-1.6C251.9,137.3,253,136.1,254.4,136.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M264,148.3h67.4c2.8,0,5-2.2,5-5H259C259,146.1,261.3,148.3,264,148.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M95.9,210.1c-5.3-23-39.7-22.4-48.1-2c-7.4,13.9,0,34.6,16.5,37c-0.2,0.7-0.9,6-1.6,5.9 c-14-0.9-11.4,10.2-11.4,10.2l30.6-0.3l9.3,0.3c0,0,0.1-8.1-5.3-9.9s-6.8,0.8-7.9-6C94.3,241.9,101,225.1,95.9,210.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M62.2,250.1c-3.9-0.4-10.8,2.4-11.3,6.8c-0.1,0.7,0.7-0.8,1.2-1.4c0.5-0.6,5.6-4.6,8.7-4.3h21.8 c3.6-0.2,6.8,3.6,7.7,6.9c0.1,0.6,0.7,0.8,0.7,0.2c0.4-3.8-4.9-8.5-8.6-8.1H80l-1.3-4.6c29.6-7.6,23.3-54.7-7.8-53.8 c-31.2-0.7-37.2,46.4-7.4,53.9L62.2,250.1z M64.3,250.1l1-4.2c3.8,0.8,7.8,0.8,11.6,0l0.7,4L64.3,250.1z M45.6,219.2 c0-33.3,50.1-35,50.9-0.2C97.4,252.3,45.8,252.5,45.6,219.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 71.2,
    cy: 219.4,
    r: 22.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.8,216.1c-0.5-0.6-1-1.2-1.6-1.6c0.5-2.6,6.4-2.7,6.5-5.9c-0.3-10.2-18.4-9.5-18.2,0.1c0,2.1,1.5,4.2,3,6.5 c1.6,2.3,1.7,2.8,1.3,4.1c-2.9,0.7-5-4.8-8.1-3.6c-12,7.8,5.3,29,14.8,8c3.4,0.3,0.1,7.1,2.7,9.1C89.6,239.2,94.8,212.4,74.8,216.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M94.4,219c-0.1-5.4-2-10.7-5.5-14.9c-0.8-1-1.4,0.4-0.5,1.4c3.1,3.8,4.8,8.7,4.7,13.6 c0.6,17.7-22.3,28.1-35.7,16.5c-0.4-0.3-1.1-0.3-1.4,0.2c-0.3,0.4-0.3,1.1,0.2,1.4C70.7,249.7,95,238.2,94.4,219z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M48.6,219.1c-0.5-17.5,22.2-28.8,35.5-17.6c0.4,0.3,1.2,1,1.6,0.6c0.3-0.4,0.3-1-0.1-1.3c0,0,0,0-0.1,0 c-14.6-12.2-38.5-0.6-37.9,18.5c0,5.3,1.8,10.4,5.1,14.6c0.9,1,1.4-0.3,0.6-1.4C50.3,228.6,48.6,223.9,48.6,219.1L48.6,219.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M74.9,233.4c15,6.7,21.4-21.1,0.5-17.3c-0.5-0.6-1-1.2-1.6-1.7c0.5-2.7,6.6-2.8,6.8-6.1 c-0.3-10.7-19.2-10-19.1,0c0.2,2.7,1.1,5.3,2.7,7.4c0.8,1.1,1.9,2,1.4,3.5c-2.8,0.3-4.9-4.8-8.1-3.6C44.9,223.8,63,246,73,224 C75.4,226.3,72.2,231.2,74.9,233.4z M71,222.4c-4.3,0.1-4.4-6.8,0-6.8C75.4,215.6,75.4,222.5,71,222.4z M65.8,214.5 c-9.2-11.4,10.7-17.6,12.7-6.2c-0.7,1.6-5.1,2.4-6.2,5.6c-2.1-0.6-4.3,0.2-5.6,1.8C66.4,215.3,66.1,214.9,65.8,214.5L65.8,214.5z  M64.6,231.1c-7.2,3.1-13.4-10.2-6.3-13.7c1.8-0.2,4.3,3.6,7.6,3.2c0.6,1.9,2.3,3.3,4.3,3.6C69.3,227.2,67.3,229.6,64.6,231.1 L64.6,231.1z M76.3,219c0-0.4,0-0.8-0.1-1.1c17-2.7,11,18.7-0.2,13.9c-1.1-1.8,1.1-5.5-1.4-8.8C75.8,221.9,76.4,220.5,76.3,219 L76.3,219z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M53.6,258.5c2.5,0.5,5.2,0,7.8-0.3c2.8-0.3,5.6-0.4,8.4-0.3c5.6,0,11.3,0.3,16.9-0.3c0.6,0,0.6-1,0-1 c-5.5,0.6-11.1,0.3-16.7,0.3c-2.7,0-5.5,0.1-8.2,0.4c-2.7,0.3-5.4,0.6-8.1,0.6c-0.1,0-0.3,0.1-0.3,0.2S53.5,258.5,53.6,258.5 L53.6,258.5L53.6,258.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M316.7,162.9c-2.9,4.3,3.6,8.8,6.5,4.6S319.7,158.6,316.7,162.9z M321.4,166.2c-1.3,1.9-4.2-0.2-2.9-2 C319.8,162.3,322.7,164.3,321.4,166.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 315.8,
    cy: 100,
    r: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M309.3,137c6.2,0.8,7.4-8.7,1.1-9.5C304.2,126.7,303.1,136.4,309.3,137z M310.1,130.2 c2.8,0.3,2.3,4.6-0.4,4.2C307,134.1,307.4,129.8,310.1,130.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 296.5,
    cy: 130.2,
    r: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M299.6,208.1c-2.5,3.6,3,7.5,5.6,3.9S302.2,204.4,299.6,208.1z M303.7,210.9c-0.6,0.6-1.6,0.6-2.2-0.1 c-0.4-0.4-0.5-1.1-0.3-1.7C302.3,207.6,304.8,209.3,303.7,210.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 324.8,
    cy: 124.9,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M134.2,112.6c-29-2.9-25.5-27.5-31.2-58.9c-0.2-1-5.3,10-5,10.9C105.2,91.3,102.5,111.7,134.2,112.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.6,105.1c7.1,8.6,4.1,24.3,2.2,31.3s4.3,9,4.3,9c-1.5,4.2-3.6,17.3,3.6,22.5c-0.3,8.2,21.1,17.2,24.6,12.1 c-15.2,22.5,39.8,21.1,27.5-2.9c4.4,8.5,12.9,0.7,15.7-15.2c-9.1,3.6-12.8-12.1-8.1-22.4c-4.4,9.7,5.6,20.4,12.2,21.2 c-2,6.8-9.2,17.5,4.4,23.2c10.3,4.4,13.8-1.7,13.8-1.7c-1.3,46.7,62.1,25.2,40.8,9.7c47.3,34.4,78.1-73.3,10-65.9 c14.3-1.6-7.8-36-28-31.2c-14.9,3.6-17.4,16.4-20.5,12.1s-8-6.3-12-3.5c-8.1,5.6-12.6,11.7-22.3,16.8c-9.6,5.1-25.1,10.1-36.6-0.2 c-16.4-13-16.8-41.3-22.5-57c-2-3.6-8.3-8.1-12.2-11.6C69.6,86.1,94.2,95.9,92.8,115c-0.8-8.4-10.3-15.2-17-29.1 c-4.6-9.5,1.6-24-4.7-27.5c-1.2,3.1-4.7,6.3-4.8,9C65.8,81.5,70.7,89.6,83.6,105.1z M240,135.1c11.5-9.3,24.8,3.4,20.2,14.4 C257.9,139.7,253.2,129.9,240,135.1z M237.1,191.4c2.3,0.1,4.5-0.3,6.7-1c3.8-1.2,3.3-5.7,3.3-5.7 C249,191.7,242.8,195.6,237.1,191.4z M194.6,186.4c0.7,3,2.5,5.7,5,7.4c4.5,3.4,10.2-0.2,9.3-3c4.8,4,6.3-3.6,4.5-6 c3,2.6,5.7-5.4,2-5.6c6.2-0.5,11.5,4.6,4.5,9.1c0,0,2.5,4.3-3.3,3.9c0,0,1.9,7.4-8.7,8.7C197.2,202.3,194.7,187.5,194.6,186.4z  M184.1,152.5c0,0,5.8-10.2,13.1-12.6c7.3-2.3,6.6,4.1,6.6,4.1s15.2-6.6,20.6-1.6c3.6,3.5,1.2,6.3,1.2,6.3 c16-4.8,32.2,19.6,9.4,28.3c3.7,9-7.7,15.9-9.5-0.8c17.4-3.1,7.6-26.5-5.7-18.9c0,0,4.7-2.4-1-7.5c-5.7-5.1-18.1,4.9-18.1,4.9 s4.6-3.7-2.8-7.4C190.4,143.5,184.1,152.5,184.1,152.5z M192,119.5c1,2.9,1.5-1.6,6.2-0.4c4.8,1.1-3.4,7.7-7.3,5 c-8.1-5.5,15.5-22.9,19.8-18.1C203.1,103.8,191.1,116.4,192,119.5z M201,103.6c5-7.4,23.1-4.3,24.9,4.8c-11.6-13.9-24.9-3-24.9-3 c-4.2-2.1-13.2,10.2-15.2,14.2s-2.3,10.7,1.3,11.3c5.8,0.8,8.9-6.7,11.2-2.9s-9.9,11.3-14.6,6C171.6,124.3,193.7,103,201,103.6z  M133.5,160.7c0,0,6.1,1.2,5.7-8.4c-0.3-9.6-7.2-11.1-7.2-11.1s7.8,1.2,9.9,7.5C145.2,157.1,138.5,162.8,133.5,160.7z M131.2,169.1 c-5.7,5.2,2.4,20.4,10,20.4c0,0-7.9,1.7-12.5-9.1C124.1,169.5,131.2,169.1,131.2,169.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M276.1,141.1c17.6,7.9,9,23-0.4,29.5C275.6,170.6,285.5,153.6,276.1,141.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M112.2,232.2c2-0.5-3.4-9.1-5.5-6.7C104.6,226.1,109.9,232.9,112.2,232.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M241.9,120.4c3.4-10-10.1-21.7-13-21.5C238.2,98.5,257.6,113.1,241.9,120.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M269,127.1c-6.9-6.5-25.2-9-26.8-6.7C247.5,112.6,267.1,109.7,269,127.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M307.7,179.7c-2.9,4.3,3.5,8.8,6.5,4.6S310.6,175.4,307.7,179.7z M312.4,183c-1.3,1.9-4.2-0.2-2.9-2 C310.9,179.1,313.7,181.1,312.4,183z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 268.6,
    cy: 207,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 297.2,
    cy: 178.1,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M276.1,209.2c-2.9,4.2,3.5,8.7,6.5,4.5S279,205,276.1,209.2z M280.8,212.5c-1.3,1.9-4.2-0.2-2.9-2 C279.3,208.7,282.1,210.6,280.8,212.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 297,
    cy: 155.7,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 255.6,
    cy: 186.6,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 255,
    cy: 204.1,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 71.1,
    cy: 219,
    r: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.1,46.5l0.6,0.5h-0.9L74.1,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.4,48.3l-1,3.2c-2.4-2.1-4.6-3.7-5.6-4.5C78.1,47.3,81.6,47.9,81.4,48.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.1,47.1c0.1-0.3,2.3-0.3,4.8-0.2c-2.1,3.7-3.9,7.5-5.4,11.4C68.3,54.6,68.5,50.8,69.1,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M133.9,68H44.3c-6.3,0-11.3-5.1-11.3-11.3v-6.9c0-6.3,5.1-11.3,11.3-11.3h89.7c6.3,0,11.3,5.1,11.3,11.3v6.9 C145.3,62.9,140.2,68,133.9,68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M140.4,68H37.9l0,0v-1.8c0-3.4,2.8-6.2,6.2-6.2l0,0h90.2c3.4,0,6.2,2.8,6.2,6.2C140.4,66.2,140.4,68,140.4,68 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M42.3,43.5H136c0.1,0,0.3-0.2,0.3-0.4l0,0c0-0.3-0.2-0.5-0.3-0.5H42.3c-0.2,0-0.3,0.2-0.3,0.5l0,0 C41.9,43.3,42.1,43.4,42.3,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M42.3,46H136c0.1,0,0.3-0.3,0.3-0.5l0,0c0-0.3-0.2-0.4-0.3-0.4H42.3c-0.2,0-0.4,0.2-0.3,0.4l0,0 C41.9,45.7,42.1,46,42.3,46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M42.3,48.5H136c0.1,0,0.3-0.3,0.3-0.5l0,0c0-0.3-0.2-0.4-0.3-0.4H42.3c-0.2,0-0.4,0.2-0.3,0.4l0,0 C41.9,48.3,42.1,48.5,42.3,48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M80.5,57.7h19c0.6,0,1.1-0.7,1.1-1.6l0,0c0-0.9-0.5-1.5-1.1-1.5h-19c-0.6,0-1.1,0.6-1.1,1.5l0,0 C79.3,57,79.9,57.7,80.5,57.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M138.3,68.1H40.7l0,0v-0.9c0-2.3,1.9-4.2,4.2-4.2l0,0h89.3c2.3,0,4.2,1.9,4.2,4.2l0,0V68.1L138.3,68.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 105.2,
    cy: 56.1,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 75.5,
    cy: 56.1,
    r: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M51,256.2c-0.3,0.9-0.5,1.8-0.6,2.7v1.4c0.1,0.3,0.1,0.4,0.2,0.7c0,0.1,0,0.2,0.1,0.3h0.3 c0,0.1,0.1,0.2,0.2,0.1s0.2-0.1,0.1-0.2c0-0.1,0.2-0.2,0.2-0.3c0-0.1-0.1-0.3-0.1-0.3c-0.1-0.2-0.1-0.3-0.1-0.5 c-0.1-0.4-0.1-0.9-0.1-1.3c0.1-0.9,0.3-1.7,0.5-2.5c0.1-0.2-0.1-0.3-0.3-0.3C51.3,255.9,51.1,256,51,256.2L51,256.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M51.4,261.4H71c6.5,0,13.2,0.3,19.7-0.2c0.3,0,0.3-0.4,0-0.4c-6.5-0.4-13.1-0.2-19.7-0.2H51.4 C50.9,260.6,50.8,261.4,51.4,261.4L51.4,261.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M91.1,261.1c0.2-0.9,0.2-1.9,0-2.9c-0.1-0.4-0.3-0.9-0.4-1.3c-0.2-0.4-0.3-1-0.8-1.1c-0.4-0.2-0.4,0-0.4,0.2 c0.1,0.4,0.3,0.9,0.5,1.2c0.2,0.4,0.3,0.8,0.3,1.2c0.2,0.8,0.2,1.7,0,2.5C90.3,261.4,91,261.4,91.1,261.1L91.1,261.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M81.9,204.3c0.4,1.2,0.7,2.3,0.8,3.6c0,1-0.3,2.1-0.9,2.9c-0.1,0.2,0.2,0.3,0.3,0.3c0.7-0.9,1.1-2,1-3.1 c-0.1-1.3-0.3-2.6-0.8-3.8C82.4,203.8,81.9,203.9,81.9,204.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M84,207.2c0.2,0.7,0.2,1.4,0.1,2.1c-0.1,0.5-0.4,1-0.8,1.4c-0.1,0.1-0.1,0.2,0,0.3h0.3 c0.6-0.3,1.1-0.9,1.1-1.6c0.1-0.8,0.1-1.6-0.2-2.3C84.5,206.8,83.9,206.9,84,207.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M52.3,217.3c0.2-0.9,0.7-1.6,1.4-2.2c0.7-0.5,1.6-0.8,2.4-0.9c0.1,0,0.3-0.1,0.3-0.3s-0.1-0.3-0.3-0.3 c-1-0.1-2.1,0.3-2.9,1c-0.8,0.6-1.3,1.5-1.6,2.5C51.6,217.6,52.2,217.7,52.3,217.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M260.1,142.6h-1.5c0,1.5,0.6,2.8,1.7,3.8C260.5,145.1,260.4,143.8,260.1,142.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M256.1,135.4v5.2h3.6C258.8,138.6,257.6,136.8,256.1,135.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M265.2,135.8h-11.5c-1.5,0-2.7,1.2-2.7,2.7c0,0,0,0.1,0,0.1v2.1c0,1.5,1.2,2.7,2.7,2.7l0,0H269 C268.6,140.5,267.3,137.8,265.2,135.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M258.7,136.3h-4.5c-1.4,0-2.6,1.1-2.6,2.5v1.6c0,0.3,0.1,0.4,0.1,0.6c0.3-1.1,1.3-1.9,2.5-1.9h6.5 C260.1,138.1,259.4,137.1,258.7,136.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M262.9,143.4h-4.2c0,1.4,0.6,2.8,1.6,3.7C264,148.3,263,144.6,262.9,143.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 293.4,
    cy: 194.1,
    r: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M292.4,186h2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 293.4,
    y1: 189,
    x2: 293.4,
    y2: 185.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M285.3,190.7l0.5-0.9l0.5-0.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 288.6,
    y1: 191.4,
    x2: 285.9,
    y2: 189.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M286,198.7l-0.5-0.9l-0.5-0.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 288.1,
    y1: 196.3,
    x2: 285.4,
    y2: 197.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M294.4,202.8h-2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 293.4,
    y1: 199.8,
    x2: 293.4,
    y2: 202.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M301.8,197.4c-0.1,0.3-0.3,0.6-0.4,0.9c-0.2,0.3-0.4,0.6-0.6,0.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 298.7,
    y1: 196.7,
    x2: 301.4,
    y2: 198.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M300.8,188.9c0.2,0.3,0.4,0.6,0.6,0.9c0.2,0.3,0.3,0.6,0.4,0.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 298.7,
    y1: 191.4,
    x2: 301.4,
    y2: 189.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 301.6,
    cy: 110.6,
    r: 2.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 301.6,
    y1: 107.5,
    x2: 301.6,
    y2: 105.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 298.8,
    y1: 108.9,
    x2: 297.1,
    y2: 107.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 298.5,
    y1: 111.9,
    x2: 296.9,
    y2: 112.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 301.6,
    y1: 114,
    x2: 301.6,
    y2: 115.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 304.8,
    y1: 112.2,
    x2: 306.5,
    y2: 113.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 304.8,
    y1: 108.9,
    x2: 306.5,
    y2: 107.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 327.2,
    cy: 185.7,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M249,126.3c-0.4,1.8-0.8,3.7-1,5.5c8.7-0.2,15.5,9.2,12,17.6c-0.1-0.2-0.1-0.3-0.2-0.5 c-0.1,0.6-0.3,1.2-0.7,1.6c4.4,1.3,9.4,1.4,14.2,1.1C271.6,139.6,264.1,129.1,249,126.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentilationRate);
export default __webpack_public_path__ + "static/media/ventilation-rate.74d4d17ea39f8182a4b9d4f980462761.svg";
export { ForwardRef as ReactComponent };